<template>
  <div class="index_data">
    <Menu pageName="indexData" />
    <div class="admin_index_data_content">
      <div class="indexItem_area">
        <div class="indexItem_area_title">
          指标体系
          <img
            class="add action"
            src="../../../assets/add.png"
            @click="(showAddItem = true), (name = '')"
          />
        </div>
        <div name="indexItems" class="indexItems">
          <div
            :class="item1.isSelect ? 'treeNodeSelect' : 'treeNode'"
            v-show="item1.isShow"
            v-for="item1 in itemList"
            :key="item1.id"
            @click.prevent="selectItem(item1)"
            onClick="event.cancelBubble = true"
          >
            {{ item1.name }}
            <div class="actions" v-if="selectedItem.id == item1.id">
              <img
                class="add action"
                src="../../../assets/add.png"
                @click.stop="
                  (showAddItemLevelTo = true), (name = ''), (tempParentID = item1.id)
                "
              />
              <img
                class="edit action"
                src="../../../assets/edit.png"
                @click.stop="showEditItem(item1)"
              />

              <span @click.stop="">
                <a-popconfirm
                  title="确定要删除此一级指标目录嘛?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="deleteItem(item1)"
                >
                  <img class="action delete" src="../../../assets/delete_button.png" />
                </a-popconfirm>
              </span>
            </div>
            <div
              :class="item2.isSelect ? 'treeNodeSelect' : 'treeNode'"
              v-show="item2.isShow"
              v-for="item2 in item1.children"
              :key="item2.id"
              @click.stop="selectItem(item2)"
              onClick="event.cancelBubble = true"
            >
              {{ item2.name }}
              <div class="actions" v-if="selectedItem.id == item2.id">
                <img
                  v-if="pointList.length <= 0"
                  class="add action"
                  src="../../../assets/add.png"
                  @click.prevent="
                    (showAddItemLevelThree = true), (name = ''), (tempParentID = item2.id)
                  "
                />

                <img
                  class="edit action"
                  src="../../../assets/edit.png"
                  @click.stop="showEditItemTo(item2)"
                />

               <span @click.stop="">
                <a-popconfirm
                  title="确定要删除此二级指标目录嘛?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="deleteItem(item2)"
                >
                  <img class="action delete" src="../../../assets/delete_button.png" />
                </a-popconfirm>
               </span>
              </div>
              <div
                :class="item3.isSelect ? 'treeNodeSelect' : 'treeNode'"
                v-show="item3.isShow"
                v-for="item3 in item2.children"
                :key="item3.id"
                @click.stop="selectItem(item3)"
                onClick="event.cancelBubble = true"
              >
                {{ item3.name }}
                <div class="actions" v-if="selectedItem.id == item3.id">
                  <img
                    class="edit action"
                    src="../../../assets/edit.png"
                    @click.stop="showEditItemThree(item3)"
                  />
                 <span @click.stop="">
                  <a-popconfirm
                    title="确定要删除此三级指标目录嘛?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="deleteItem(item3)"
                  >
                    <img class="action delete" src="../../../assets/delete_button.png" />
                  </a-popconfirm>
                 </span>
                </div>
                <div
                  class="treeNode"
                  v-show="item4.isShow"
                  v-for="item4 in item3.children"
                  :key="item4.id"
                  @click.stop="selectItem(item4)"
                  onClick="event.cancelBubble = true"
                >
                  {{ item4.name }}
                  <div
                    class="treeNode"
                    v-show="item5.isShow"
                    v-for="item5 in item4.children"
                    :key="item5.id"
                    @click.stop="selectItem(item5)"
                    onClick="event.cancelBubble = true"
                  >
                    {{ item5.name }}
                    <div
                      class="treeNode"
                      v-show="item6.isShow"
                      v-for="item6 in item5.children"
                      :key="item6.id"
                      @click.stop="selectItem(item6)"
                      onClick="event.cancelBubble = true"
                    >
                      {{ item6.name }}
                      <div
                        class="treeNode"
                        v-show="item7.isShow"
                        v-for="item7 in item6.children"
                        :key="item7.id"
                        @click.stop="selectItem(item7)"
                        onClick="event.cancelBubble = true"
                      >
                        {{ item7.name }}
                        <div
                          class="treeNode"
                          v-show="item8.isShow"
                          v-for="item8 in item7.children"
                          :key="item8.id"
                          @click.stop="selectItem(item8)"
                          onClick="event.cancelBubble = true"
                        >
                          {{ item8.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="indexPoint_area">
        <div
          v-show="selectedItem.children && selectedItem.children.length <= 0"
          class="add_point"
          @click="showAddPointDialog()"
        >
          增加指标点
        </div>
        <IndexPointItem
          v-for="item in pointList"
          :key="item.id"
          :data="item"
          @deletePointFunc="deletePoint"
        />
      </div>
    </div>

    <div class="add_point_dialog" v-show="showAddPoint">
      <div>
        <div class="text">指标要求</div>
        <textarea v-model="requireText"> </textarea>
        <div class="text">要点提示</div>
        <textarea v-model="tipsText"></textarea>
        <div class="text">分值</div>
        <input type="text" v-model="score" />
        <div class="buttons">
          <div class="button addPoint" @click="addItemPoint">添加</div>
          <div class="button cancel" @click="showAddPoint = false">取消</div>
        </div>
      </div>
    </div>

    <div class="add_item_dialog" v-show="showAddItem">
      <div class="text">指标项</div>
      <a-textarea :rows="4" v-model="name"></a-textarea>
      <div class="buttons">
        <div class="button addPoint" @click="addItemLevelOne">添加</div>
        <div class="button cancel" @click="showAddItem = false">取消</div>
      </div>
    </div>
    <div class="add_item_dialog" v-show="showAddItemLevelTo">
      <div class="text">指标项</div>
      <a-textarea :rows="4"  v-model="name"></a-textarea>
      <div class="buttons">
        <div class="button addPoint" @click="addItemLevelTo">添加</div>
        <div class="button cancel" @click="showAddItemLevelTo = false">取消</div>
      </div>
    </div>
    <div class="add_item_dialog" v-show="showAddItemLevelThree">
      <div class="text">指标项</div>
      <a-textarea  :rows="4" v-model="name"></a-textarea>
      <div class="buttons">
        <div class="button addPoint" @click="addItemLevelThree">添加</div>
        <div class="button cancel" @click="showAddItemLevelThree = false">取消</div>
      </div>
    </div>
    <div class="add_item_dialog" v-show="EditItem">
      <div class="text">指标项</div>
      <a-textarea :rows="4" v-model="name"></a-textarea>
      <div class="buttons">
        <div class="button addPoint" @click="EditItemLevelOne">添加</div>
        <div class="button cancel" @click="EditItem = false">取消</div>
      </div>
    </div>
    <div class="add_item_dialog" v-show="EditItemTo">
      <div class="text">指标项</div>
      <a-textarea :rows="4" v-model="name"></a-textarea>
      <div class="buttons">
        <div class="button addPoint" @click="editItemLevelTwo">添加</div>
        <div class="button cancel" @click="EditItemTo = false">取消</div>
      </div>
    </div>
    <div class="add_item_dialog" v-show="EditItemThree">
      <div class="text">指标项</div>
      <a-textarea :rows="4" v-model="name"></a-textarea>
      <div class="buttons">
        <div class="button addPoint" @click="editItemLevelThree">添加</div>
        <div class="button cancel" @click="EditItemThree = false">取消</div>
      </div>
    </div>
    <!-- overlay -->
    <!-- 编辑指标点信息 -->
    <a-modal v-model="showEditPoints" title="编辑指标点信息" @ok="addPointItemV2()">
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="指标要求">
          <a-textarea v-model="form.require" place :auto-size="{ minRows: 3 }" />
        </a-form-model-item>
        <a-form-model-item label="要点提示">
          <a-textarea v-model="form.tips" place :auto-size="{ minRows: 2 }" />
        </a-form-model-item>
        <a-form-model-item label="分值">
          <a-input v-model="form.score" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import Menu from "../../../components/ProjectMenuAdmin.vue";
import IndexPointItem from "../../../components/IndexPointItem.vue";
import storeUtil from "../../../utils/storeUtil.js";
import server from "../../../interface/gradeSys.js";

export default {
  name: "",
  components: {
    Menu: Menu,
    IndexPointItem: IndexPointItem,
  },
  data() {
    return {
      selectedItem: {
        id: "",
      },
      itemList: [],
      pointList: [],
      // 添加指标点对话框
      showAddPoint: false,
      // 添加指标点需要的参数
      requireText: "",
      tipsText: "",
      score: "",
      // 添加指标项对话框
      showAddItem: false,
      showAddItemLevelTo: false,
      EditItem: false,
      EditItemTo: false,
      EditItemThree: false,
      // 指标项绑定参数
      name: "",
      // 编辑指标项时临时存储
      tempItem: {},
      // 添加二级指标项使用的父 ID
      tempParentID: "",
      showAddItemLevelThree: false,
      form: {},
      showEditPoints: false,
      showEditUser: false,
      selectUnit: [],
      indeterminate: true,
      checkAll: false,
      userList: [],
    };
  },
  mounted() {
    this.getItemData("");
  },
  methods: {
    // 添加第一级指标
    addItemLevelOne() {
      server
        .addItem({
          name: this.name,
          level: 1,
          parentID: "",
          projectID: storeUtil.getProject().id,
        })
        .then((res) => {
          console.log(res);
          this.showAddItem = false;
          this.getItemData("");
        });
    },
    showEditItem(item) {
      this.tempItem = item;
      this.EditItem = true;
      this.name = item.name;
    },

    // 编辑一级指标项
    EditItemLevelOne() {
      server
        .editItem({
          name: this.name,
          id: this.tempItem.id,
        })
        .then((res) => {
          console.log(res);
          this.EditItem = false;
          this.getItemData("");
        });
    },
    // 删除指标项
    deleteItem(item) {
      // console.log(item);
      server
        .deleteItem({
          id: item.id,
        })
        .then((res) => {
          console.log(res);
          this.getItemData("");
        });
    },
    // 添加第二级指标
    addItemLevelTo() {
      server
        .addItem({
          name: this.name,
          level: 2,
          parentID: this.tempParentID,
          projectID: storeUtil.getProject().id,
        })
        .then((res) => {
          console.log(res);
          this.showAddItemLevelTo = false;
          this.getItemData(this.tempParentID);
        });
    },
    // 编辑第二级指标项
    showEditItemTo(item) {
      this.name = item.name;
      this.EditItemTo = true;
      this.tempItem = item;
    },
    editItemLevelTwo(item) {
      console.log(item);
      server
        .editItem({
          name: this.name,
          id: this.tempItem.id,
        })
        .then((res) => {
          console.log(res);
          this.EditItemTo = false;
          this.getItemData(this.tempItem.parentID);
        });
    },

    // 第三极指标点
    addItemLevelThree() {
      server
        .addItem({
          name: this.name,
          level: 3,
          parentID: this.tempParentID,
          projectID: storeUtil.getProject().id,
        })
        .then((res) => {
          console.log(res);
          this.showAddItemLevelThree = false;
          this.getItemData(this.tempParentID);
        });
    },
    showEditItemThree(item) {
      this.name = item.name;
      this.EditItemThree = true;
      this.tempItem = item;
    },
    editItemLevelThree() {
      server
        .editItem({
          name: this.name,
          id: this.tempItem.id,
        })
        .then((res) => {
          console.log(res);
          this.EditItemThree = false;
          this.getItemData(this.tempItem.parentID);
        });
    },
    showAddPointDialog() {
      // this.showAddPoint = true;
      this.showEditPoints = true;
      this.form = {};
      this.requireText = "";
      this.tipsText = "";
      this.score = "";
    },
    addPointItemV2() {
      server
        .addItemPoint({
          ...this.form,
          indexItemID: this.selectedItem.id,
        })
        .then((res) => {
          this.showEditPoints = false;
          console.log(res);
          this.getPointData(this.selectedItem.id);
        });
    },
    // 添加指标点
    addItemPoint() {
      server
        .addItemPoint({
          require: this.requireText,
          tips: this.tipsText,
          score: this.score,
          indexItemID: this.selectedItem.id,
        })
        .then((res) => {
          this.showAddPoint = false;
          console.log(res);
          this.getPointData(this.selectedItem.id);
        });
    },
    // 删除指标点
    deletePoint(item) {
      console.log("delete..." + JSON.stringify(item));
      server
        .deleteItemPoint({
          id: item.id,
        })
        .then((res) => {
          console.log(res);
          this.getPointData(this.selectedItem.id);
        });
    },
    selectItem(item) {
      if (this.selectedItem) {
        this.selectedItem.isSelect = false;
      }

      console.log("click..." + JSON.stringify(item));

      this.selectedItem = item;
      this.selectedItem.isSelect = true;
      if (this.selectedItem.children.length > 0) {
        this.selectedItem.children = [];
      } else {
        this.getItemData(this.selectedItem.id);
      }
    },
    getItemData(parentID) {
      // 点击指标项时，把指标点清楚
      this.pointList = [];
      server
        .indexItemList({
          parentID: parentID,
          project: storeUtil.getProject().id,
        })
        .then((result) => {
          if (parentID == "") {
            this.selectedItem = { id: "" };
            this.itemList = [];
            this.expandedKeys = [];
            this.selectedKeys = [];
            if (result.length && result.length > 0) {
              for (var i = 0; i < result.length; ++i) {
                this.itemList.push({
                  id: result[i].id,
                  name: result[i].name,
                  parentID: result[i].parentID,
                  level: result[i].level,
                  project: result[i].project,
                  isShow: true,
                  isSelect: false,
                  children: [],
                });
              }
            }
          } else {
            if (result.length && result.length > 0) {
              let item = this.findItem(this.itemList);
              item.children = [];
              for (var j = 0; j < result.length; ++j) {
                item.children.push({
                  id: result[j].id,
                  name: result[j].name,
                  parentID: result[j].parentID,
                  level: result[j].level,
                  project: result[j].project,
                  isShow: true,
                  isSelect: false,
                  children: [],
                });
              }
            } else {
              this.getPointData(this.selectedItem.id);
            }
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    getPointData(id) {
      server
        .indexPointList({
          indexItemID: id,
        })
        .then((result) => {
          this.pointList = result;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    findItem(itemList) {
      for (let k = 0; k < itemList.length; ++k) {
        if (itemList[k].id == this.selectedItem.id) {
          return itemList[k];
        }
      }

      for (let k = 0; k < itemList.length; ++k) {
        if (itemList[k].children && itemList[k].children.length > 0) {
          let result = this.findItem(itemList[k].children);
          if (result) {
            return result;
          }
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
.index_data {
  .admin_index_data_content {
    overflow-y: auto;
    display: flex;

    .indexItem_area {
      flex: 4;
      background-color: white;
      width: 790px;
      position: absolute;
      bottom: 0;
      left: 0;
      top: 80px;
      padding-right: 20px;
      padding-left: 58px;

      .indexItem_area_title {
        margin-top: 20px;
        color: #464e58;
        font-family: "Source Han Sans CN";
        font-weight: 700;
        font-size: 24px;

        .add {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .indexItems {
        overflow-y: scroll;
        position: absolute;
        bottom: 10px;
        left: 0;
        top: 80px;

        width: 770px;

        .actions {
          float: right;
          display: inline;

          .action {
            width: 20px;
            margin: 5px;
            height: 20px;
          }
        }

        .treeNode {
          cursor: pointer;

          padding-left: 40px;
          margin-top: 15px;
          color: #666666;
          font-family: "Source Han Sans CN";
          font-family: "Source Han Sans CN";
          font-weight: 400;
          font-size: 20px;
        }

        .treeNodeSelect {
          cursor: pointer;
          padding-left: 40px;
          margin-top: 15px;
          color: #4265ed;
          font-family: "Source Han Sans CN";
          color: #4265ed;
          font-family: "Source Han Sans CN";
          font-weight: 400;
          font-size: 20px;
        }
      }
    }

    .indexPoint_area {
      flex: 6;
      overflow: auto;
      position: absolute;
      left: 800px;
      bottom: 10px;
      top: 90px;
      right: 10px;

      .add_point {
        color: white;
        line-height: 44px;
        text-align: center;
        margin-top: 30px;
        margin-left: 60px;
        cursor: pointer;
        width: 134px;
        height: 44px;
        background: #4265ed;
        opacity: 1;
        border-radius: 4px;
      }
    }
  }

  .add_point_dialog {
    width: 800px;
    position: absolute;
    top: 20%;
    left: 30%;
    padding: 40px 80px;
    background-color: white;
    box-shadow: #66666660 5px 5px 5px 5px;

    .buttons {
      margin: 20px;

      display: flex;
      justify-content: space-around;

      .button {
        cursor: pointer;
        width: 33%;
        height: 44px;
        line-height: 44px;
        background-color: #4265ed;
        border-radius: 5px;
        text-align: center;
        color: white;
      }

      .cancel {
        background-color: #8e8e8e66;
      }
    }

    .text {
      font-size: 18px;
    }

    textarea {
      margin: 10px 0px;
      width: 100%;
      min-height: 60px;
      max-height: 100px;
    }
  }

  .add_item_dialog {
    position: absolute;
    left: 30%;
    width: 800px;
    top: 20%;
    padding: 40px 80px;
    background-color: white;
    box-shadow: #66666660 5px 5px 5px 5px;

    textarea {
      margin: 10px 0px;
      width: 100%;
      min-height: 60px;
      max-height: 100px;
    }

    .text {
      font-size: 18px;
    }

    .buttons {
      margin: 20px;

      display: flex;
      justify-content: space-around;

      .button {
        cursor: pointer;
        width: 33%;
        height: 44px;
        line-height: 44px;
        background-color: #4265ed;
        border-radius: 5px;
        text-align: center;
        color: white;
      }

      .cancel {
        background-color: #8e8e8e66;
      }
    }
  }
}
</style>
